export const TOUR_TARGETS = {
  DASHBOARD_TABS: 'admin-tour-dashboard-tabs',
  REGIONS_MANAGER: 'admin-tour-regions-manager',
  REGION_CARDS: 'admin-tour-region-cards',
  SHOPIFY_INTEGRATION: 'admin-tour-shopify-integration',
  CONTENT_MANAGER: 'admin-tour-content-manager',
  REGION_LOOKS: 'admin-tour-region-looks',
  REGION_LOOKS_SECTION: 'admin-tour-region-looks-section',
  PRODUCTS: 'admin-tour-products',
  PRODUCT_CARDS: 'admin-tour-product-cards',
  RETAILERS: 'admin-tour-retailers',
  RETAILERS_TABLE: 'admin-tour-retailers-table',
  LOCATIONS: 'admin-tour-locations',
  LOCATIONS_SECTION: 'admin-tour-locations-section',
  ORDERS: 'admin-tour-orders',
  ORDERS_TABLE: 'admin-tour-orders-table',
};
